import { TicketCreation } from '../containers/TicketCreation';
import { usePortalData } from '../data/usePortalData';
import { useFormData } from '../data/useFormData';
import { useTicketCreation } from './TicketCreationProvider';
import { ModalPanel } from 'foundations-components/transitional/components/ModalPanel';
import { PanelSection } from 'foundations-components/transitional/components/Panel';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { Text } from 'foundations-components/components/Text';
import I18n from 'I18n';
import { useEffect } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function TicketCreationPanel() {
  var _portalData$settings$, _portalData$settings;
  const {
    isOpen,
    close
  } = useTicketCreation();
  const {
    data: portalData,
    loading: portalLoading
  } = usePortalData();
  const {
    data: formData,
    loading: formLoading
  } = useFormData();
  const title = (_portalData$settings$ = portalData === null || portalData === void 0 || (_portalData$settings = portalData.settings) === null || _portalData$settings === void 0 ? void 0 : _portalData$settings.formHeaderText) !== null && _portalData$settings$ !== void 0 ? _portalData$settings$ : '';
  const hasForm = !!(formData !== null && formData !== void 0 && formData.formGuid);
  useEffect(() => {
    if (!portalLoading && !formLoading && (!hasForm || !portalData)) {
      close();
    }
  }, [portalLoading, formLoading, hasForm, portalData, close]);
  if (!isOpen || !hasForm || !portalData) {
    return null;
  }
  return /*#__PURE__*/_jsxs(ModalPanel, {
    width: 560,
    paddingInline: "600",
    onEsc: close,
    onBackdropClick: close,
    children: [/*#__PURE__*/_jsx(DialogCloseButton, {
      onClick: close,
      "aria-label": I18n.text('customer-portal-app.ticketListings.ticketCreationCloseButton'),
      color: "icon-core-default"
    }), /*#__PURE__*/_jsx(Text, {
      as: "h4",
      typography: "heading-500",
      color: "text-core-default",
      paddingBlock: "600",
      paddingInline: "600",
      children: title
    }), /*#__PURE__*/_jsx(PanelSection, {
      padding: "0",
      flush: true,
      children: /*#__PURE__*/_jsx(TicketCreation, {
        onSuccess: close,
        formData: formData,
        portalData: portalData
      })
    })]
  });
}